import * as React from 'react'

const SvgTextItalicIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.625 5.625v-1.25H7.5v1.25h3.213l-2.732 8.75H4.375v1.25H12.5v-1.25H9.287l2.732-8.75h3.606z"
      fill="#163250"
    />
  </svg>
)

export default SvgTextItalicIcon
